// frontend/src/lib/zoteroFileMatch.ts
import type { ManifestEntry } from "@/types/zoteroImport";

export type StorageIndex = Map<string, File>; // "<KEY>/<filename>" -> File

/** Index files from one or more webkitdirectory picks by storage key + name. */
export function buildStorageIndex(files: File[]): StorageIndex {
  const idx: StorageIndex = new Map();
  for (const f of files) {
    const rel = (f as File & { webkitRelativePath?: string }).webkitRelativePath ?? "";
    const m = rel.match(/storage\/([^/]+)\/(.+)$/);
    if (m) idx.set(`${m[1]}/${m[2]}`, f);
  }
  return idx;
}

export interface MatchedEntry { entry: ManifestEntry; file: File | null; }

export function matchManifest(
  entries: ManifestEntry[],
  index: StorageIndex,
): MatchedEntry[] {
  return entries.map((entry) => {
    const file = entry.filename
      ? index.get(`${entry.attachment_key}/${entry.filename}`) ?? null
      : null;
    return { entry, file };
  });
}
